import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";
// import rootReducer from "./reducer";

// const store: Store = createStore(rootReducer, compose(composeWithDevTools(applyMiddleware(thunk))));

const store = configureStore({
	reducer: rootReducer,
	devTools: true,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({ serializableCheck: false }),
});

export type dispatch = typeof store.dispatch;
export default store;
